import React, { useEffect, useRef } from 'react';

const TwitterEmbed = ({ url, title }) => {
  const embedRef = useRef(null);

  useEffect(() => {
    if (window.twttr && window.twttr.widgets) {
      window.twttr.widgets.load(embedRef.current);
    }
  }, [url]);

  return (
    <div ref={embedRef} className=".tp-project-single-video-container-twitter">
      {title && (
        <div className="tp-project-single-title">
          <h3>{title}</h3>
        </div>
      )}
      <blockquote className="twitter-tweet" data-media-max-width="900">
        <a href={url}></a>
      </blockquote>
    </div>
  );
};

export default TwitterEmbed;
